import { parseAmountEther } from 'shared/lib/token/units';

export const GENESIS_PRIVILEGES_LINK =
  'https://cratd2csmartchain.gitbook.io/cit-genesis-mint/cit-token-genesis-mint-event';
export const HOW_TO_BUY = 'https://dex-trade.com/ieo/CIT';

export const HARD_CAP = parseAmountEther((30_000_000).toString(), 18);

export const END_TIMESTAMP = 1779062399000; // MAY 17th, 2026 - 11:59 PM UTC (timestamp in ms)
